// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { TimelineDateIndicator } from '@/components/timeline-date-indicator';
import { useTheme } from '@mui/material';
import { DateTime } from 'luxon';
import { ComponentProps } from 'react';

type TimelineDateIndicatorProps = ComponentProps<typeof TimelineDateIndicator>;
type Props = Omit<TimelineDateIndicatorProps, 'dateTime' | 'color'>;

/**
 * An indicator that marks midnight on the current date on a timeline.
 */
export function TimelineCurrentDateIndicator(props: Props) {
  const theme = useTheme();

  const today = DateTime.now().startOf('day');

  return (
    <TimelineDateIndicator
      y={props.y}
      color={theme.palette.primary.main}
      scale={props.scale}
      height={props.height}
      dateTime={today}
    />
  );
}
